/**
 * The wizard's eight step ids, and nothing else.
 *
 * Its own module with ZERO imports on purpose. The run detail route's
 * `validateSearch` schema is loaded eagerly by `router.tsx` (that is how
 * TanStack Router parses a URL before the lazy component arrives), so anything
 * that schema imports lands in the initial chunk. When these ids lived in
 * `payroll-run-wizard.ts`, the eager import dragged that file's step labels,
 * copy and lucide icons into the initial bundle with them, against a
 * 150 KB budget that has about 2 KB of headroom (P1).
 *
 * Eight strings is what the URL parser actually needs. Everything the wizard
 * knows ABOUT a step stays in `payroll-run-wizard.ts`, in the lazy chunk.
 *
 * C-15 (payroll depth, technical design 6.1) replaced the single `resolve`
 * step with `preflight` and added `inputs` and `variance`. `resolve` is gone
 * rather than kept as an alias: a stale `?step=resolve` link is clamped back
 * to the run's own active step by `resolveRunWizardStep`, which is what that
 * clamp exists for, and keeping a ninth id alive would mean keeping a step
 * nothing routes to.
 */
export const WIZARD_STEP_IDS = [
  "define",
  "inputs",
  "employees",
  "process",
  "preflight",
  "variance",
  "publish",
  "pay",
] as const;

export type WizardStepId = (typeof WIZARD_STEP_IDS)[number];
